import { createAction, props } from '@ngrx/store';
import { GroupFilters } from '@shared/models/group-filters';

export const setGroupFilters = createAction('[Customers] Set Group Filters', props<{ filters: GroupFilters }>());
